// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1M751","mobile":"Header_mobile__1W1F1","navLinks":"Header_navLinks__3OJH5"};